import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { doc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../../lib/firebase";
import DailySchedule from "../Schedule/DailySchedule";
import StatusBoard from "./StatusBoard";

export default function CommandPage({ fieldMode = false, onLock }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState("daily");

  const isSmallScreen =
    typeof window !== "undefined" &&
    window.matchMedia("(max-width: 768px)").matches;

  return (
    <div style={styles.shell}>
      <div style={{ ...styles.header, ...(isSmallScreen ? styles.headerMobile : {}) }}>
        <div style={styles.title}>Command</div>

        <div style={styles.tabs}>
          <button
            style={tab === "daily" ? styles.tabActive : styles.tab}
            onClick={() => setTab("daily")}
          >
            Daily Ops
          </button>

          <button style={styles.tab} onClick={() => navigate("/field-access/hq")}>
            PT Tracker
          </button>

          <button
            style={styles.tab}
            onClick={() =>
              navigate("/field-access/hq", {
                state: { activeTab: "patients" },
              })
            }
          >
            Patients
          </button>

          <button style={styles.tab} onClick={() => navigate("/field-access/dispatch")}>
            Dispatch
          </button>

          <button
            style={tab === "status" ? styles.tabActive : styles.tab}
            onClick={() => setTab("status")}
          >
            Status Board
          </button>
        </div>

        {fieldMode ? (
          <button style={styles.lockBtn} onClick={onLock}>
            Lock
          </button>
        ) : (
          <button style={styles.adminBtn} onClick={() => navigate("/admin")}>
            Return to Admin
          </button>
        )}
      </div>

      <div style={{ ...styles.content, ...(isSmallScreen ? styles.contentMobile : {}) }}>
        {tab === "daily" ? <DailySchedule /> : <StatusBoard compact fieldMode />}
      </div>
    </div>
  );
}

const styles = {
  shell: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    background: "#f8fafc",
    overflow: "auto",
  },
  header: {
    height: 52,
    flex: "0 0 auto",
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "8px 14px",
    background: "#0f172a",
    borderBottom: "1px solid #1e293b",
  },
  title: {
    color: "#fff",
    fontWeight: 900,
    fontSize: 18,
  },
  tabs: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },
  tab: {
    padding: "8px 12px",
    background: "#1e293b",
    color: "#fff",
    border: "1px solid #334155",
    borderRadius: 8,
    fontWeight: 700,
    cursor: "pointer",
  },
  tabActive: {
    padding: "8px 12px",
    background: "#0ea5e9",
    color: "#fff",
    border: "1px solid #38bdf8",
    borderRadius: 8,
    fontWeight: 700,
    cursor: "pointer",
  },
  adminBtn: {
    marginLeft: "auto",
    background: "#22c55e",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: 8,
    fontWeight: 700,
    cursor: "pointer",
  },
  lockBtn: {
    marginLeft: "auto",
    background: "#ef4444",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: 8,
    fontWeight: 700,
    cursor: "pointer",
  },
  content: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
  },
  headerMobile: {
    height: "auto",
    flexWrap: "wrap",
    alignItems: "stretch",
  },
  contentMobile: {
    overflow: "auto",
  },
};